import { useEffect } from 'react';
import AOS from 'aos';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import HeroSection from '../Section/HeroSection';
import WhyChooseMeSection from '../Section/WhyChooseMeSection';
import ProcessSection from '../Section/ProcessSection';
import FAQSection from '../Section/FAQSection';
import Hire from '../Hire-me';
import PricingSection from '../Section/PricingSection';

function AllServices() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-out',
      once: true,
      offset: 50,
    });
  }, []);

  return (
    <div className="services-page">
      <HeroSection />
      <WhyChooseMeSection />
      <ProcessSection />
      <PricingSection />
      <FAQSection />
      <Hire />
    </div>
  );
}

export default AllServices;
